export default __webpack_public_path__ + "buysearchsell/images/buysearchsell_white_logo.svg";